import { Box, Dialog } from "@mui/material";

type Props = {
  onClose: () => void;
  open: boolean;
};

export default function ExtensaoVideoDialog({ onClose, open }: Props) {
  return (
    <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth>
      <Box
        component="iframe"
        src="https://www.youtube.com/embed/WJQoaQtYDQ4"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Demonstração da Extensão Felix na Bolsa"
        sx={{
          display: "block",
          width: "100%",
          height: 512,
          border: 0,
        }}
      />
    </Dialog>
  );
}
